<div class="grid ">
<div class="col-12">
	<div class="card" *ngIf="!permissaoInserir">
		<div style="text-align: center;">
			<h4>Você não possui permissão de acesso essa página!</h4>
		</div>
	</div>
	<div class="card" *ngIf="permissaoInserir">
			<form #f="ngForm" name="form" novalidate>
				<div class="formgroup">
					<div class="p-fluid p-formgrid grid mb-3">
						<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
							<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
						</div>
							<div class="field col-12 md:col-4">
								<label htmlFor="descricao">Descrição</label>
								<input oninput="this.value = this.value.toUpperCase();"
								 name="descricao" type="text" pInputText placeholder="Digite a descrição"
									ngModel [(ngModel)]="conta.descricao" oninput="this.value = this.value.toUpperCase();"
									#descricao="ngModel" required />
								<div *ngIf="descricao.hasError('required') && descricao.touched">
									<small>Campo obrigatório</small>
								</div>
								
							</div>
							<div class="field col-12 md:col-2">
								<label htmlFor="tipo">Tipo de Conta</label>
								<p-dropdown [options]="tipoConta" placeholder="Selecione" name="tipo"
								ngModel #tipo="ngModel" [(ngModel)]="conta.tipoConta" [required]="true">
								</p-dropdown>
							</div>
					</div>
						<div class="p-fluid p-formgrid grid justify-content-between">
							<div class="col-12 md:col-4" >
								<button *ngIf="!progressoRequisicao else exibirBotaoFalso"
									type="submit" pButton icon="pi pi-check" label="Salvar"
									(click)="salvar()"	class="p-button-outlined p-button-success md:w-9rem" [disabled]="!f.valid">
								</button>
								<ng-template #exibirBotaoFalso>
									<button type="submit" pButton icon="pi pi-spin pi-spinner" label="Salvar"
									class="p-button-outlined p-button-success md:w-9rem" [disabled]="true">
									</button>
								</ng-template>
							</div>
							<div class="col-12 md:col-4 flex justify-content-end">
								<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
									class="p-button-outlined md:w-9rem" routerLink="/apps/conta"></button>
							</div>
						</div>
					</div>
				</form>
			</div>
	</div>
</div>
